import './question.css';
import Amplify, { Auth } from 'aws-amplify';
import { Hint } from 'react-autocomplete-hint';

import React, { useState, useEffect, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import { cx, css } from '@emotion/css';
import * as styles from './challanges.style.js';
import { selectMedium } from '../../styles/components/forms.style';
import EditBatchIcon from '../../assets/images/edit-batch.png';
import { find, get } from 'lodash';
import { useRef } from 'react';

const overlayStyles = css`
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(10, 4, 0, 0.72);
  backdrop-filter: blur(6px);
`;

const cardStyles = css`
  position: relative;
  width: 100%;
  max-width: 600px;
  background: linear-gradient(160deg, #fff9f4 0%, #fdfbf7 100%);
  border-radius: 24px;
  border: 1.5px solid rgba(241, 102, 2, 0.2);
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(255, 255, 255, 0.6) inset;
  padding: 36px;
  font-family: 'Inter', sans-serif;
  overflow: hidden;
  max-height: 90vh;
  overflow-y: auto;
  
  &::-webkit-scrollbar { width: 6px; }
  &::-webkit-scrollbar-track { background: rgba(0,0,0,0.05); border-radius: 10px; }
  &::-webkit-scrollbar-thumb { background: rgba(241,102,2,0.4); border-radius: 10px; }
`;

const closeBtnStyles = css`
  position: absolute;
  top: 18px;
  right: 18px;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: none;
  background: rgba(241, 102, 2, 0.08);
  color: #888;
  font-size: 1.2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  &:hover { background: rgba(241, 102, 2, 0.15); color: #f16602; transform: scale(1.1) rotate(90deg); }
`;

const headerTitleStyles = css`
  font-size: 1.8rem;
  font-weight: 800;
  color: #1a1a1a;
  text-align: center;
  margin-bottom: 24px;
  margin-top: 0;
  span { background: linear-gradient(90deg, #f16602, #ff8c42); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
`;

const inputStyles = css`
  width: 100%;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid rgba(241,102,2,0.25);
  background: #fff;
  font-size: 0.95rem;
  font-family: 'Inter', sans-serif;
  color: #333;
  transition: all 0.2s;
  box-sizing: border-box;
  &:focus { outline: none; border-color: #f16602; box-shadow: 0 0 0 3px rgba(241,102,2,0.15); }
`;

const formRow = css`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  > * { flex: 1; min-width: 200px; }
`;

const labelStyle = css`
  display: block;
  font-size: 0.85rem;
  font-weight: 700;
  color: #666;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const submitBtnStyle = css`
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  border: none;
  background: linear-gradient(135deg, #f16602 0%, #d94f00 100%);
  color: #fff;
  font-size: 1.05rem;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 6px 20px rgba(241, 102, 2, 0.38);
  transition: transform 0.18s, box-shadow 0.18s;
  margin-top: 28px;
  text-transform: uppercase;
  letter-spacing: 1px;
  &:hover { transform: translateY(-2px); box-shadow: 0 10px 28px rgba(241, 102, 2, 0.48); }
`;

const checkboxRow = css`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 16px 0 24px;
  font-weight: 700;
  color: #444;
  font-size: 0.95rem;
  cursor: pointer;
  input[type="checkbox"] { width: 20px; height: 20px; accent-color: #f16602; cursor: pointer; }
`;

const totalTimeBar = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, rgba(241,102,2,0.12), rgba(255,200,100,0.08));
  border: 1px solid rgba(241,102,2,0.2);
  border-radius: 12px;
  padding: 12px 18px;
  margin-top: 16px;
  grid-column: 1 / -1;

  span:first-child {
    font-size: 0.88rem;
    font-weight: 600;
    color: #4a4a4a;
  }
  span:last-child {
    font-size: 0.95rem;
    font-weight: 800;
    color: #f16602;
  }
`;

const formatTimeDisplay = (seconds) => {
  if (seconds === 0) return 'No time limit';
  if (seconds >= 60) {
    const m = seconds / 60;
    return `${m === Math.floor(m) ? m : m.toFixed(1)} min`;
  }
  return `${seconds} sec`;
};

const formatTotalTime = (seconds) => {
  if (seconds === 0) return 'No time limit';
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  if (m > 0 && s > 0) return `${m} min ${s} sec`;
  if (m > 0) return `${m} min`;
  return `${s} sec`;
};



function getEquallyNumbArray(number, numberOfSplit) {
  if (
    numberOfSplit > number ||
    typeof number !== 'number' ||
    typeof numberOfSplit !== 'number'
  ) {
    throw new Error('invalid arguments');
  }

  const result = [];

  for (let i = 1; i <= numberOfSplit; i++) {
    result.push(Math.floor(number / numberOfSplit));
  }

  const sumOfResult = result.reduce((a, b) => {
    return a + b;
  }, 0);

  if (sumOfResult === number) return result;

  const remainder = number - sumOfResult;
  const resultLength = result.length;

  if (remainder === 1) {
    result[resultLength - 1] = result[resultLength - 1] + remainder;
  } else {
    for (let i = remainder; i > 0; i--) {
      result[resultLength - i] = result[resultLength - i] + 1;
    }
  }

  return result;
}

function PopUp(props) {
  const [eventtype, setEventtype] = React.useState('Assignments');
  const [eventname, setEventname] = React.useState('');
  const [status, setStatus] = React.useState('Create Challenge');
  const [username, setUserName] = React.useState('');
  const [useremail, setUserEmail] = React.useState('');


  const [premiumlevel, set_premiumlevel] = useState(0);

  //  const [level, setLevel] = React.useState("");
  const [category, setCategory] = React.useState('');
  const [builtincategory, setBuiltincategory] = React.useState([]);
  const [grade, setGrade] = React.useState(1);

  const [checked, setChecked] = React.useState(true);
  const [disablecategory, disableCategory] = React.useState(true);
  const [disabledropdown, disableDropDown] = React.useState(false);
  const [disablequestiontype, disableQuestiontype] = React.useState(true);
  const [formerrors, setformerrors] = React.useState(false);
  const [errorreason, seterrorreason] = React.useState('');

  const questiontypes = ['TextwithRadioButton', 'QuestionswithTextField'];

  const getReadableQuestionType = (type) => {
    switch (type) {
      case 'TextwithRadioButton':
        return 'Multiple Choice Questions (MCQ)';
      case 'QuestionswithTextField':
        return 'Fill in the blanks / Text Input';
      case 'ImagewithTextField':
        return 'Image with Text Input';
      case 'ImagewithRadioButton':
        return 'Image with Multiple Choice';
      case 'SpeakTextwithTextField':
        return 'Speak & Text Input';
      default:
        return type;
    }
  };
  // const questiontypes = [
  //   'TextwithRadioButton',
  //   'SpeakTextwithTextField',
  //   'ImagewithTextField',
  //   'QuestionswithTextField',
  // ];

  const categorytypes = [
    'Mathematics',
    'General Knowledge',
    'Chess',
    'SpellBowl',
    'Languages',
  ];

  const [questiontype, setQuestiontype] = React.useState('');
  const [specificcategory, setSpecificCategory] = React.useState([]);
  const [timeforassignment, setTimeforassignment] = React.useState(60);
  const [level, setLevel] = React.useState(5);

  const [token, set_token] = React.useState('');
  const [totalno, setTotal] = React.useState('5');
  const [batches2, setBatches2] = React.useState([]);

  const [predefinedcategorys, set_predefinedcategorys] = React.useState([]);

  const [questionlevel, set_questionlevel] = React.useState([]);

  //  const eventypes = ["Assignments", "Event"]
  //  const questiontypes = ["ImagewithTextField", "ImagewithRadioButton", "TextwithRadioButton","TextwithTextField","SpeakTextwithTextField"]

  const selectCategoryRef = useRef(null);

  const eventypes = ['Assignments'];



  const timeOptions = [0, 5, 10, 15, 30, 45, 60, 90, 120, 180, 300];
  const noofquestionsoptions = [2, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100];



  const grades = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  // const predefinedcategorys = ["Spell Bowl 0","Spell Bowl 1","Spell Bowl 2"]

  const batchtype = ['Batch1', 'Batch2', 'Batch3', 'Batch4', 'Batch5'];
  const batches1 = [];

  const predefinedcategorys_12 = [
    {
      specificategory: 'Select Builtin Questions...',
      level: 12,
      category: 'None',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1-50',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 51-100',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 101-150',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 151-200',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 201-250',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 251-300',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 301-350',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 351-400',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 401-450',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 451-500',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 501-550',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 551-600',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 601-650',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 651-700',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 701-750',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 751-800',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 801-850',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 851-900',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 901-950',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 951-1000',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1001-1050',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1051-1100',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1101-1150',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1151-1200',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1201-1250',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1251-1300',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1301-1350',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1351-1400',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1401-1450',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1451-1500',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1501-1550',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1551-1600',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1601-1650',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1651-1700',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1701-1750',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1751-1800',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1801-1850',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1851-1900',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1901-1950',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1951-2000',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 2001-2050',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 2051-2100',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 2101-2150',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 2151-2200',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
  ];
  const predefinedcategorys_11 = [
    {
      specificategory: 'Select Builtin Questions...',
      level: 12,
      category: 'None',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1-50',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 51-100',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 101-150',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 151-200',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 201-250',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 251-300',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 301-350',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 351-400',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 401-450',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 451-500',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 501-550',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 551-600',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 601-650',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 651-700',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 701-750',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 751-800',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 801-850',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 851-900',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 901-950',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 951-1000',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1001-1050',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1051-1100',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1101-1150',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1151-1200',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1201-1250',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1251-1300',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1301-1350',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1351-1400',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1401-1450',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1451-1500',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1501-1550',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1551-1600',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1601-1650',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1651-1700',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1701-1750',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1751-1800',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1801-1850',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1851-1900',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1901-1950',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1951-2000',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 2001-2050',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 2051-2100',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 2101-2150',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 2151-2200',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
  ];
  const predefinedcategorys_10 = [
    {
      specificategory: 'Select Builtin Questions...',
      level: 12,
      category: 'None',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1-50',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 51-100',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 101-150',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 151-200',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 201-250',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 251-300',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 301-350',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 351-400',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 401-450',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 451-500',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 501-550',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 551-600',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 601-650',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 651-700',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 701-750',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 751-800',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 801-850',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 851-900',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 901-950',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 951-1000',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1001-1050',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1051-1100',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1101-1150',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1151-1200',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1201-1250',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1251-1300',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1301-1350',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1351-1400',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1401-1450',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1451-1500',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1501-1550',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1551-1600',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1601-1650',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1651-1700',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1701-1750',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1751-1800',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1801-1850',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1851-1900',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1901-1950',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1951-2000',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 2001-2050',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 2051-2100',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 2101-2150',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 2151-2200',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
  ];
  const predefinedcategorys_9 = [
    {
      specificategory: 'Select Builtin Questions...',
      level: 12,
      category: 'None',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1-50',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 51-100',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 101-150',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 151-200',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 201-250',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 251-300',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 301-350',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 351-400',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 401-450',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 451-500',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 501-550',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 551-600',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 601-650',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 651-700',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 701-750',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 751-800',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 801-850',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 851-900',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 901-950',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 951-1000',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1001-1050',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1051-1100',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1101-1150',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1151-1200',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1201-1250',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1251-1300',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1301-1350',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1351-1400',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1401-1450',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1451-1500',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1501-1550',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1551-1600',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1601-1650',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1651-1700',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1701-1750',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1751-1800',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1801-1850',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1851-1900',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1901-1950',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 1951-2000',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 2001-2050',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 2051-2100',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 2101-2150',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Senior 2026 Words 2151-2200',
      level: 9,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
  ];

  const predefinedcategorys_8 = [
    {
      specificategory: 'Select Builtin Questions...',
      level: 8,
      category: 'None',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1-50',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 51-100',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 101-150',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 151-200',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 201-250',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 251-300',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 301-350',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 351-400',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 401-450',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 451-500',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 501-550',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 551-600',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 601-650',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 651-700',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 701-750',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 751-800',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 801-850',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 851-900',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 901-950',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 951-1000',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1001-1050',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1051-1100',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1101-1150',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1151-1200',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1201-1250',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1251-1300',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1301-1350',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1351-1400',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
  ];

  const predefinedcategorys_7 = [
    {
      specificategory: 'Select Builtin Questions...',
      level: 8,
      category: 'None',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1-50',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 51-100',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 101-150',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 151-200',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 201-250',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 251-300',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 301-350',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 351-400',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 401-450',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 451-500',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 501-550',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 551-600',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 601-650',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 651-700',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 701-750',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 751-800',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 801-850',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 851-900',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 901-950',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 951-1000',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1001-1050',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1051-1100',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1101-1150',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1151-1200',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1201-1250',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1251-1300',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1301-1350',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1351-1400',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
  ];
  const predefinedcategorys_6 = [
    {
      specificategory: 'Select Builtin Questions...',
      level: 8,
      category: 'None',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1-50',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 51-100',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 101-150',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 151-200',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 201-250',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 251-300',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 301-350',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 351-400',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 401-450',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 451-500',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 501-550',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 551-600',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 601-650',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 651-700',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 701-750',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 751-800',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 801-850',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 851-900',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 901-950',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 951-1000',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1001-1050',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1051-1100',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1101-1150',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1151-1200',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1201-1250',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1251-1300',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1301-1350',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Junior 2026 Words 1351-1400',
      level: 6,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
  ];


  const predefinedcategorys_6_special = [
    {
      specificategory: 'Select Builtin Questions...',
      level: 6,
      category: 'None',
    },
    ...predefinedcategorys_6.filter((item) => item.category === 'SpellBowl'),
    {
      specificategory: 'EARTH SCIENCE Questions 400-450',
      level: 5,
      category: 'ScienceBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'EARTH SCIENCE Questions 200-250',
      level: 5,
      category: 'ScienceBowl',
      questiontype: 'SpeakTextwithTextField',
    },



    {
      specificategory: 'AddSubstractNumbers',
      level: 6,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },
    {
      specificategory: 'Mixed Operations',
      level: 6,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },
    {
      specificategory: 'Multiply Whole Numbers',
      level: 6,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },
    {
      specificategory: 'Place values',
      level: 6,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },
    {
      specificategory: 'Writing Words in Numbers',
      level: 6,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    }
  ];

  const predefinedcategorys_5 = [
    {
      specificategory: 'Select Builtin Questions...',
      level: 0,
      category: 'None',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 1-50',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 51-100',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 101-150',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 151-200',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 201-250',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },

    {
      specificategory: 'Spell Bowl Elementary 2026 Words 251-300',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 301-350',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 351-400',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 401-450',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 451-500',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 501-550',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 551-600',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 601-650',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 651-700',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 701-750',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },

    {
      specificategory: 'Decimal Addition',
      level: 5,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },
    {
      specificategory: 'Algebra Solve 2 Equations',
      level: 5,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },
    {
      specificategory: 'MultiStep Equations 1',
      level: 5,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },
    {
      specificategory: 'MultiStep Equations 2',
      level: 5,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },
    {
      specificategory: 'FindRemainders',
      level: 5,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },
    {
      specificategory: 'pemdas',
      level: 5,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },
    {
      specificategory: 'Fraction Word Problems',
      level: 5,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },
    {
      specificategory: 'PrimeNumbers',
      level: 5,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },
    {
      specificategory: 'Algebra Word Problems',
      level: 5,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },
    {
      specificategory: 'Guess Number Problems',
      level: 5,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },
    {
      specificategory: 'Percentage Questions1',
      level: 5,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },
    {
      specificategory: 'Percentage Questions2',
      level: 5,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },

    {
      specificategory: 'Mean Puzzles',
      level: 5,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },

    {
      specificategory: 'Mode Puzzles',
      level: 5,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },

    {
      specificategory: 'Range Puzzles',
      level: 5,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },
    {
      specificategory: 'Median Puzzles',
      level: 5,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },
    {
      specificategory: 'Ratio Find Equations',
      level: 5,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },
    {
      specificategory: 'Ratio Find Numbers',
      level: 5,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },
    {
      specificategory: 'Ratio Order Numbers',
      level: 5,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },
    {
      specificategory: 'Ratio Add Numbers',
      level: 5,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },
    {
      specificategory: 'Ratio Basic Puzzles',
      level: 5,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },
    {
      specificategory: 'Math Puzzles',
      level: 3,
      category: 'Mathematics',
      questiontype: 'QuestionswithTextField',
    },
  ];

  const predefinedcategorys_1 = [
    {
      specificategory: 'Select Builtin Questions...',
      level: 0,
      category: 'None',
    },
    {
      specificategory: 'Word Problems Addition',
      level: 1,
      category: 'Mathematics',
    },
    {
      specificategory: 'Word Problems Subtraction',
      level: 1,
      category: 'Mathematics',
    },
    {
      specificategory: 'Word Problems Time',
      level: 1,
      category: 'Mathematics',
    },
  ];
  const predefinedcategorys_2 = [
    {
      specificategory: 'Select Builtin Questions...',
      level: 0,
      category: 'None',
    },

    {
      specificategory: 'Word Problems Addition',
      level: 2,
      category: 'Mathematics',
    },
    {
      specificategory: 'Word Problems Subtraction',
      level: 2,
      category: 'Mathematics',
    },
    {
      specificategory: 'Word Problems Multiplication',
      level: 2,
      category: 'Mathematics',
    },
    {
      specificategory: 'Word Problems Division',
      level: 2,
      category: 'Mathematics',
    },

    {
      specificategory: 'Word Problems Money',
      level: 2,
      category: 'Mathematics',
    },
  ];

  const predefinedcategorys_3 = [
    {
      specificategory: 'Select Builtin Questions...',
      level: 0,
      category: 'None',
    },

    {
      specificategory: 'Capitals',
      level: 3,
      category: 'Capitals',
      questiontype: 'TextwithRadioButton',
    },
    {
      specificategory: 'Flags',
      level: 3,
      category: 'Flags',
      questiontype: 'TextwithRadioButton',
    },

    {
      specificategory: 'Currencies',
      level: 3,
      category: 'Currencies',
      questiontype: 'TextwithRadioButton',
    },

    {
      specificategory: 'Space and Planets',
      level: 3,
      category: 'Space',
      questiontype: 'TextwithRadioButton',
    },
    {
      specificategory: 'Tigers',
      level: 3,
      category: 'Animals',
      questiontype: 'TextwithRadioButton',
    },
    {
      specificategory: 'Snakes',
      level: 3,
      category: 'Animals',
      questiontype: 'TextwithRadioButton',
    },
    {
      specificategory: 'Turtles',
      level: 3,
      category: 'Animals',
      questiontype: 'TextwithRadioButton',
    },

    {
      specificategory: 'Geography',
      level: 3,
      category: 'Geography',
      questiontype: 'TextwithRadioButton',
    },

    {
      specificategory: 'Brain Puzzles',
      level: 3,
      category: 'Brain Puzzles',
      questiontype: 'TextwithRadioButton',
    },
    {
      specificategory: 'Olympics',
      level: 3,
      category: 'Sports',
      questiontype: 'TextwithRadioButton',
    },
    {
      specificategory: 'Swimming',
      level: 3,
      category: 'Sports',
      questiontype: 'TextwithRadioButton',
    },
    {
      specificategory: 'Track and Field',
      level: 3,
      category: 'Sports',
      questiontype: 'TextwithRadioButton',
    },

    {
      specificategory: 'Word Problems Multiplication',
      level: 3,
      category: 'Mathematics',
      questiontype: 'TextwithRadioButton',
    },
    {
      specificategory: 'Word Problems Addition',
      level: 3,
      category: 'Mathematics',
      questiontype: 'TextwithRadioButton',
    },
    {
      specificategory: 'Word Problems Division',
      level: 3,
      category: 'Mathematics',
      questiontype: 'TextwithRadioButton',
    },
    {
      specificategory: 'Word Problems Money',
      level: 3,
      category: 'Mathematics',
      questiontype: 'TextwithRadioButton',
    },
    {
      specificategory: 'Word Problems Time',
      level: 3,
      category: 'Mathematics',
      questiontype: 'TextwithRadioButton',
    },
    {
      specificategory: 'Mixed Fractions Addition',
      level: 3,
      category: 'Mathematics',
      questiontype: 'TextwithRadioButton',
    },
    {
      specificategory: 'Mixed Fractions Subtraction',
      level: 3,
      category: 'Mathematics',
      questiontype: 'TextwithRadioButton',
    },

    {
      specificategory: 'Decimal Addition',
      level: 3,
      category: 'Mathematics',
      questiontype: 'TextwithRadioButton',
    },
    {
      specificategory: 'Decimal Subtraction',
      level: 3,
      category: 'Mathematics',
      questiontype: 'TextwithRadioButton',
    },
    {
      specificategory: 'Algebra Division',
      level: 3,
      category: 'Mathematics',
      questiontype: 'TextwithRadioButton',
    },
    {
      specificategory: 'Missing Addition',
      level: 3,
      category: 'Mathematics',
      questiontype: 'TextwithRadioButton',
    },

    {
      specificategory: 'Missing Subtraction',
      level: 3,
      category: 'Mathematics',
      questiontype: 'TextwithRadioButton',
    },

    {
      specificategory: 'Percentage Word Problems 3',
      level: 3,
      category: 'Mathematics',
      questiontype: 'TextwithRadioButton',
    },

    {
      specificategory: 'Fractions Addition',
      level: 3,
      category: 'Mathematics',
      questiontype: 'TextwithRadioButton',
    },

    {
      specificategory: 'Fractions Subtraction',
      level: 3,
      category: 'Mathematics',
      questiontype: 'TextwithRadioButton',
    },
    {
      specificategory: 'Fractions Multiplication',
      level: 3,
      category: 'Mathematics',
      questiontype: 'TextwithRadioButton',
    },
    {
      specificategory: 'Fractions Division',
      level: 3,
      category: 'Mathematics',
      questiontype: 'TextwithRadioButton',
    },
    {
      specificategory: 'Addition',
      level: 3,
      category: 'Mathematics',
      questiontype: 'TextwithRadioButton',
    },
    {
      specificategory: 'Subtraction',
      level: 3,
      category: 'Mathematics',
      questiontype: 'TextwithRadioButton',
    },
    {
      specificategory: 'Multiplication',
      level: 3,
      category: 'Mathematics',
      questiontype: 'TextwithRadioButton',
    },
    {
      specificategory: 'Division',
      level: 3,
      category: 'Mathematics',
      questiontype: 'TextwithRadioButton',
    },
  ];

  const predefinedcategorys_4 = [
    {
      specificategory: 'Select Builtin Questions...',
      level: 0,
      category: 'None',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 1-50',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 51-100',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 101-150',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 151-200',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 201-250',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },

    {
      specificategory: 'Spell Bowl Elementary 2026 Words 251-300',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 301-350',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 351-400',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 401-450',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 451-500',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 501-550',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 551-600',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 601-650',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 651-700',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
    {
      specificategory: 'Spell Bowl Elementary 2026 Words 701-750',
      level: 4,
      category: 'SpellBowl',
      questiontype: 'SpeakTextwithTextField',
    },
  ];




  const getToken = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      let jwt = user.signInUserSession.accessToken.jwtToken;

      setUserEmail(user.attributes['email'])

      if (user.username.includes("Google_")) {
        set_token(jwt);
        setUserName(user.attributes['email'])
        getuserDetails(user.attributes['email'], jwt);
        getEventsfromDB(user.attributes['email'], jwt);
      }
      else {
        set_token(jwt);
        setUserName(user.username)
        getuserDetails(user.username, jwt);
        getEventsfromDB(user.username, jwt);
      }








    } catch (error) {
      // console.log(error)
      // Auth.signOut(); // Avoid aggressive signout on simple navigation failures
    }
  };


  // const getToken = async () => {
  //   Auth.currentSession().then((res) => {
  //     ////console.log("Auth.currentSession()")
  //     let accessToken = res.getAccessToken();
  //     ////console.log("accessToken called ")
  //     let jwt = accessToken.getJwtToken();
  //     ////console.log("Got jwt ")
  //     let useremail = Auth.user.attributes.email;

  //     ////console.log(useremail)
  //     set_token(jwt);


  //     getuserDetails(Auth.user.username, jwt);

  //     getEventsfromDB(Auth.user.username, jwt);
  //   });
  // };

  const getuserDetails = async (username, jwt) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      body: JSON.stringify({ username: username }),
    };
    const response = await fetch(
      `https://api.quizwizard.net/quiz/getuser`,
      requestOptions
    );
    const data = await response.json();

    set_premiumlevel(data['premiumuser'])

  }



  const createEvent = async (username, useremail, jwt) => {
    const id = Date.now();

    var requestOptions = {};

    if (!disabledropdown) {
      requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: jwt },
        // body: JSON.stringify({'question': id , 'tablename': category+"Questions",'level': level})
        body: JSON.stringify({
          appname: 'QuizWhiz',
          category: category,
          completed: 0,
          description: category,
          eventenddate: '2081-01-31',
          eventowner: username,
          eventstartdate: '2011-01-31',
          eventstarted: 0,
          eventtype: eventtype,
          id: id,
          level: parseInt(level),
          levels: ('' + questionlevel).split(',').map(Number),
          // limits: totalno.toString().split(',').map(Number),
          limits: getEquallyNumbArray(parseInt(totalno), questionlevel.length),

          maxnoofparticipants: 50000,
          minnoofparticipants: 1,
          name: eventname,
          points: 0,
          qualificationno: parseInt(totalno),
          rewards: '',
          subcategory: eventname,
          time: timeforassignment,
          totalquestions: totalno,
          email: useremail,
          active: true,
          noofretries: 0,
          premiumevent: 0,
          parent: id,
          eventdisplay: questiontype,
          sendEmail: true,
          specificcategory: ('' + specificcategory).split(',').map(String),
          complexity: 1,
        }),
      };
    } else {
      requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: jwt },
        // body: JSON.stringify({'question': id , 'tablename': category+"Questions",'level': level})
        body: JSON.stringify({
          appname: 'QuizWhiz',
          category: category,
          completed: 0,
          description: category,
          eventenddate: '2081-01-31',
          eventowner: username,
          eventstartdate: '2011-01-31',
          eventstarted: 0,
          eventtype: eventtype,
          id: id,
          level: parseInt(level),
          levels: ('' + id).split(',').map(Number),
          limits: ('' + totalno).split(',').map(Number),
          maxnoofparticipants: 10000,
          minnoofparticipants: 1,
          name: eventname,
          points: 0,
          qualificationno: 0,
          rewards: '',
          subcategory: eventname,
          time: timeforassignment,
          totalquestions: totalno,
          email: useremail,
          active: true,
          noofretries: 0,
          premiumevent: 0,
          parent: id,
          eventdisplay: questiontype,
          sendEmail: true,
          specificcategory: ('' + category).split(',').map(String),
          complexity: 1,
        }),
      };
    }

    //console.log(requestOptions)
    try {
      const response = await fetch(
        `https://api.quizwizard.net/quiz/createevent`,
        requestOptions
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      ////console.log(data)
      props.selected();
    } catch (e) {
      alert("Error creating challenge: " + e.toString());
      setStatus("Error Creating Challenge");
    }
  };
  const getEventsfromDB = async (username, jwt) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      body: JSON.stringify({ username: username }),
    };

    const response = await fetch(
      `https://api.quizwizard.net/quiz/listbatchesbyowner`,
      requestOptions
    );
    const data = await response.json();
    ////console.log('Output from the API is ')
    ////console.log(data)

    var i, j;
    var loopData = [];
    var count = 0;

    for (i = 0; i < data.length; i++) {
      //////console.log(data[i]['events'][0])
      for (j = 0; j < data[i]['events'].length; j++) {
        //////console.log(data[i]['events'][j])
        loopData[count] = data[i]['events'][j];
        ////console.log("loopData[count]")
        ////console.log(loopData[count])
        var obj = {
          batchname: loopData[count]['name'],
          id: loopData[count]['id'],
        };
        ////console.log(obj)
        batches1[count] = obj;
        count = count + 1;
      }
    }

    ////console.log(batches1)

    setBatches2(batches1);

    // set_batches(loopData)
    // set_loadedevents(true)
  };

  function getGradelevelBuiltInQuestions(value) {

    setGrade(value);

    if (value == 1) {
      set_predefinedcategorys(predefinedcategorys_1);
    } else if (value == 2) {
      set_predefinedcategorys(predefinedcategorys_2);
    } else if (value == 3) {

      set_predefinedcategorys(predefinedcategorys_3);
    } else if (value == 4) {
      set_predefinedcategorys(predefinedcategorys_4);
    } else if (value == 5) {
      set_predefinedcategorys(predefinedcategorys_5);
    } else if (value == 6 && premiumlevel >= 10) {
      set_predefinedcategorys(predefinedcategorys_6_special);

    } else if (value == 6) {
      set_predefinedcategorys(predefinedcategorys_6);
    }

    else if (value == 7) {
      set_predefinedcategorys(predefinedcategorys_7);
    } else if (value == 8) {
      set_predefinedcategorys(predefinedcategorys_8);
    } else if (value == 9) {
      set_predefinedcategorys(predefinedcategorys_9);
    } else if (value == 10) {
      set_predefinedcategorys(predefinedcategorys_10);
    } else if (value == 12 && premiumlevel >= 100) {
      set_predefinedcategorys(predefinedcategorys_12);
    }
  }
  function showpredefined() {
    if (!checked) {
      disableCategory(true);
      disableDropDown(false);
      disableQuestiontype(true);
    } else {
      disableCategory(false);
      disableDropDown(true);
      disableQuestiontype(false);
    }

    setChecked(!checked);
    ////console.log(checked)
    ////console.log(disablecategory)
    ////console.log(disabledropdown)
  }

  // const setBuiltinCategory = (e) => {

  //   let index = e.nativeEvent.target.selectedIndex;
  //   let label = e.nativeEvent.target[index].text;
  //   let value = e.target.value;

  //   setCategory(label)

  // }

  function setBuiltinCategory(event) {

    // console.log(event)

    //let index = event.nativeEvent.target.selectedIndex;

    const values = event.map((e) => e.value);
    const labels = event.map((e) => e.label);

    const res = predefinedcategorys.filter((item) => {
      return values.includes(item.specificategory);
    });


    const scategory = res.map((item) => item.category);
    const squestiontype = res.map((item) => item.questiontype);
    const slevel = res.map((item) => item.level);


    let category = scategory[0]
    let questiontype = squestiontype[0]


    setCategory(category);
    setQuestiontype(questiontype);
    set_questionlevel(slevel);
    setSpecificCategory(labels);
    setBuiltincategory(values);
  }

  useEffect(() => {
    // You need to restrict it at some point
    // This is just dummy code and should be replaced by actual
    // ////console.log("useEffect called on EventsScreen")
    getToken();

    document.title = 'Create Challenge';





  }, []);

  function selectedanswer() {
    if (!disabledropdown) {
      if (eventname == '') {
        setformerrors(true);
        seterrorreason('Invalid Event Name');
      } else if (!category || category == 'Select Builtin Questions' || builtincategory.length === 0) {
        setformerrors(true);
        seterrorreason('Invalid Category');
      } else {
        setStatus('Creating Challenge.....');
        createEvent(username, Auth.user.attributes.email, token);
      }
    } else {
      //console.log(questiontype)

      if (eventname == '') {
        setformerrors(true);
        seterrorreason('Invalid Event Name');
      } else if (!category || category == 'Category') {
        setformerrors(true);
        seterrorreason('Invalid Category');
      } else if (!questiontype || questiontype == 'Question Type') {
        setformerrors(true);
        seterrorreason('Invalid Question Type');
      } else {
        setStatus('Creating Challenge.....');
        createEvent(username, Auth.user.attributes.email, token);
      }
    }
  }

  return (
    <div className={overlayStyles} onClick={props.handleClose}>
      <div className={cardStyles} onClick={e => e.stopPropagation()}>
        {formerrors && (
          <div style={{ color: '#d94f00', background: 'rgba(241, 102, 2, 0.1)', padding: 12, borderRadius: 8, marginBottom: 16, textAlign: 'center', fontWeight: 'bold' }}>
            {errorreason}
          </div>
        )}

        <button className={closeBtnStyles} onClick={props.handleClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>

        <h3 className={headerTitleStyles}>Create <span>Challenge</span></h3>

        <div style={{ marginBottom: 16 }}>
          <label className={labelStyle}>Event Name</label>
          <input
            className={inputStyles}
            name="eventname"
            type="text"
            spellCheck="false"
            autoComplete="off"
            value={eventname}
            onChange={(e) => setEventname(e.target.value)}
            placeholder="e.g. Weekly Math Challenge"
            required
          />
        </div>

        <div style={{ marginBottom: 16 }}>
          <label className={labelStyle}>Select Batch</label>
          <Select
            className={selectMedium}
            classNamePrefix="select"
            placeholder="Select batch"
            name="level"
            required
            value={
              level.toString().length && {
                value: level,
                label: get(find(batches2, { id: level }), 'batchname'),
              }
            }
            options={batches2.map((batch) => ({
              value: batch.id,
              label: batch.batchname,
            }))}
            onChange={(val) => setLevel(val.value)}
          />
        </div>

        <label className={checkboxRow}>
          <input
            type="checkbox"
            checked={checked}
            onChange={() => showpredefined()}
          />
          Use Built-in Questions
        </label>

        <div className={formRow}>
          <div>
            <label className={labelStyle}>Grade</label>
            <Select
              className={selectMedium}
              name="timeforassigments"
              classNamePrefix="select"
              value={{ label: `Grade ${grade}`, value: grade }}
              placeholder="Grades"
              onChange={(e) => {
                getGradelevelBuiltInQuestions(e.value);
                setBuiltincategory([]);
                selectCategoryRef?.current?.clearValue();
              }}
              required
              options={grades.map((grades1) => ({ label: `Grade ${grades1}`, value: grades1 }))}
            />
          </div>

          {!checked ? (
            <div>
              <label className={labelStyle}>Category Type</label>
              <Select
                className={selectMedium}
                classNamePrefix="select"
                placeholder="Category Type"
                name="questiontype"
                required
                value={category ? { value: category, label: category } : null}
                options={categorytypes.map((qt) => ({ value: qt, label: qt }))}
                onChange={(val) => setCategory(val.value)}
              />
            </div>
          ) : (
            <div>
              <label className={labelStyle}>Built-in Category</label>
              <Select
                className={selectMedium}
                classNamePrefix="select"
                placeholder="Built-in Category"
                name="builtinquestion"
                required
                isMulti
                hideSelectedOptions={false}
                ref={selectCategoryRef}
                value={builtincategory.map(val => ({ value: val, label: val }))}
                options={predefinedcategorys.map((cat) => ({ value: cat.specificategory, label: cat.specificategory }))}
                onChange={(val) => setBuiltinCategory(val || [])}
              />
            </div>
          )}

          {!checked && (
            <div>
              <label className={labelStyle}>Question Type</label>
              <select
                className={inputStyles}
                name="questiontype"
                disabled={disablequestiontype}
                value={questiontype}
                onChange={(e) => setQuestiontype(e.target.value)}
                required
              >
                <option value="">Select Type...</option>
                {questiontypes.map((qt) => (
                  <option key={qt} value={qt}>{getReadableQuestionType(qt)}</option>
                ))}
              </select>
            </div>
          )}
        </div>

        <div className={formRow}>
          <div>
            <label className={labelStyle}>No. of Questions</label>
            <Select
              className={selectMedium}
              name="noofquestions"
              classNamePrefix="select"
              value={{ label: totalno, value: totalno }}
              placeholder="No of Questions"
              onChange={(e) => setTotal(e.value)}
              required
              options={noofquestionsoptions.map((times) => ({ label: times, value: times }))}
            />
          </div>
          <div>
            <label className={labelStyle}>Time per question</label>
            <Select
              className={selectMedium}
              name="timeforassigments"
              classNamePrefix="select"
              value={{ label: formatTimeDisplay(timeforassignment), value: timeforassignment }}
              placeholder="Time per question"
              onChange={(e) => setTimeforassignment(e.value)}
              required
              options={timeOptions.map((times) => ({ label: formatTimeDisplay(times), value: times }))}
            />
          </div>
        </div>
        <div className={totalTimeBar}>
          <span>Total Session Time</span>
          <span>{formatTotalTime(timeforassignment * (parseInt(totalno) || 0))}</span>
        </div>

        <button className={submitBtnStyle} onClick={selectedanswer}>
          {status}
        </button>
      </div>
    </div>
  );
}

export default PopUp;
